module.exports = __webpack_public_path__ + "static/media/bestbuy_big.6b0592e3.png";